var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{attrs:{"items":_vm.items,"divider":" / "},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [(item.to)?_c('router-link',{attrs:{"to":item.to}},[_vm._v(_vm._s(item.text))]):_c('span',[_vm._v(_vm._s(item.text))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }